import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseHttpService } from "../base-http.service";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class PersonalReportsService extends BaseHttpService {
    constructor(private http: HttpClient) {
        super();
    }

    fetchReports(type?: string) {
        let url = `${this.baseUrl}/remotestorage/reports`;
        if (type) {
            url += `?type=${type}`;
        }
        return this.http.get<any>(url);
    }

    fetchFrenchCertificate() {
        return this.http.get<any>(
            `${this.baseUrl}/remotestorage/french-certificate`
        );
    }

    markReportAsRead(reportId: number): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/remotestorage/reports/${reportId}/mark-read`,
            {}
        );
    }

    getUnreadCount(): Observable<{
        count: number;
        unreadFuelReports?: number;
        unreadTachographReports?: number;
    }> {
        return this.http.get<{
            count: number;
            unreadFuelReports?: number;
            unreadTachographReports?: number;
        }>(`${this.baseUrl}/remotestorage/reports/unread-count`);
    }
}
